@if(currentSection === 'planDetails'){
<div class="flex-1 px-300-rem py-250-rem">
  <div>
    <div class="flex flex-col space-y-050-rem">
      <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Plan details</h1>
      <p class="text-container-fg-muted text-label-md-weight-regular">
        Select the firmware package this plan will roll out.
      </p>
    </div>
    <div
      class="border border-container-border-default rounded-050 mt-[24px] bg-container-bg-default max-w-[846px]">
      <div class="max-w-[456px] p-100-rem">
        <h3 class="text-label-lg-weight-medium text-container-fg-default">
          Firmware package to roll out
        </h3>
        <div class="flex gap-x-025-rem py-100-em w-xl">
          <i
            class="icon_marina_ui_InfoOutlined text-container-fg-muted text-headline-sm"
            aria-hidden="true"></i>
          <p class="text-container-fg-muted text-body-lg-weight-regular">
            Only Released packages that aren’t used by another rollout plan are shown. Selection
            becomes locked after first plan activation.
          </p>
        </div>
        <mat-form-field [ngClass]="{'error-border': error}">
          <mat-label
            >{{ isEditingRolloutPlan() ? selectedVersion() : 'Firmware package bundle version'
            }}</mat-label
          >
          <mat-select [(value)]="selected" [disabled]="isEditingRolloutPlan()">
            @for (eligiblePackages of eligiblePackages(); track eligiblePackages.id) {
            <mat-option [value]="eligiblePackages">{{eligiblePackages.version}}</mat-option>
            } @empty {
            <mat-option disabled>
              No eligible firmware package bundle versions available.
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if(error){
        <div
          class="flex items-center text-label-sm-weight-regular gap-025-em text-feedback-fg-error mt-025-em">
          <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
          <span> {{ error }}</span>
        </div>
        } @else {
        <p class="text-container-fg-muted text-label-sm-weight-regular w-sm pt-025-rem">
          Don’t see it? Make sure the package is Released and not already used in another plan.
        </p>
        }
      </div>
    </div>
  </div>
</div>
}
